import "./sidebar.scss";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import SettingsSystemDaydreamOutlinedIcon from "@mui/icons-material/SettingsSystemDaydreamOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import config
 from "../../../../config";

var url = config.nav.url;

var logout_link = url+'logout';

const Sidebar = () => {
  const { t } = useTranslation();

  const type = localStorage.getItem("type");
  useEffect(()=>{
    // if(type !== 'admin' && type !== 'exam'){
    //   navigate('/');
    // }
  })

  return (
    <div className="sidebar">
      <div className="top">
        <Link to="/admin" style={{ textDecoration: "none" }}>
          <img src="/assets/logo.png" alt="About" className="logo w-75 "/>
        </Link>
      </div>
      <hr />
      <div className="center">
        <ul>
          <p className="title">MAIN</p>
          <Link to="/admin" style={{ textDecoration: "none" }}>
              <li>
                <DashboardIcon className="icon" />
                <span>{t('dashboard')}</span>
              </li>
          </Link>
          <p className="title">{t('APPLICATIONS')}</p>
          <Link to="/admin/candidats" style={{ textDecoration: "none" }}>
            <li>
              <PsychologyOutlinedIcon className="icon" />
              <span>{t('applications')}</span>
            </li>
          </Link>
          {
            type === 'exam' ?
            <Link to="/admin/report" style={{ textDecoration: "none" }}>
              <li>
                <PsychologyOutlinedIcon className="icon" />
                <span>{t('my_report')}</span>
              </li>
            </Link>
            :
            <></>
          }
          {
            type === 'admin' ?
            <Link to="/../dashboard" style={{ textDecoration: "none" }}>
              <li>
                <PsychologyOutlinedIcon className="icon" />
                <span>{t('my_application')}</span>
              </li>
            </Link>
            :
            <></>
          }
          <p className="title">{t('POSTS')}</p>
          <Link to="/admin/posts" style={{ textDecoration: "none" }}>
            <li>
              <InsertChartIcon className="icon" />
              <span>{t('posts')}</span>
            </li>
          </Link>
          {
            type === 'admin' ?
            <div>
              <p className="title">{t('MEMBERS')}</p>
              <Link to="/admin/examinators" style={{ textDecoration: "none" }} >
                <li>
                  <AccountCircleOutlinedIcon className="icon" />
                  <span>{t('examinators')}</span>
                </li>
              </Link>
              <Link to="/admin/administrators" style={{ textDecoration: "none" }}>
                <li>
                  <SettingsSystemDaydreamOutlinedIcon className="icon" />
                  <span>{t('administrators')}</span>
                </li>
              </Link>
            </div>
          :
            <></>
          }
          <p className="title">{t('SETTINGS')}</p>
          <Link to={logout_link} style={{ textDecoration: "none" }}>
            <li>
              <i className="fa fa-sign-out text-white"></i><span>{t('logout')}</span>
            </li>
          </Link>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
